import { createListenerMiddleware, isAnyOf } from "@reduxjs/toolkit";
import { commonApi } from "../api/commonApi";
import { changeCode, changeSessionId, logout } from "../slices/authSlice";

let bitrixScriptInjected = false;

function getBitrixWidgetButton() {
  const shadowElements = document.getElementsByClassName("b24-widget-button-shadow");
  if (shadowElements) {
    const shadowElement = shadowElements[0] as HTMLElement;
    if (shadowElement?.parentElement) {
      return shadowElement.parentElement;
    }
  }
}

// Hide Bitrix widget when user logs out
function hideBitrixWidget() {
  const button = getBitrixWidgetButton();
  if (button) {
    button.style.display = "none";
  }

  if ("bitrixWidget" in window && window["bitrixWidget"]) {
    // @ts-ignore
    const widget = window["bitrixWidget"];

    // @ts-ignore
    widget.setUserRegisterData({
      hash: "",
    });
  }
}

// Show Bitrix widget and update user data
function showBitrixWidget(bitrixData: Common.BitrixDataProps) {
  if ("bitrixWidget" in window && window["bitrixWidget"]) {
    // @ts-ignore
    const widget = window["bitrixWidget"];

    // Update user hash
    // @ts-ignore
    widget.setUserRegisterData({
      hash: bitrixData.hash,
    });

    // Show the widget
    const button = getBitrixWidgetButton();
    if (button) {
      button.style.display = "";
    }

    // Hide the contact form button if hash exists
    if (bitrixData.hash) {
      setTimeout(() => {
        const button = document.querySelector(bitrixData.widgetCrmFormButton);
        if (button) {
          (button as HTMLElement).style.display = "none";
        }
      }, 100);
    }
  }
}

// Helper to inject Bitrix script into HTML (only once)
function injectBitrixScript(bitrixData: Common.BitrixDataProps) {
  // Only inject if not already injected
  if (bitrixScriptInjected) {
    return;
  }

  // Create and inject inline script with widget configuration
  const inlineScript = document.createElement("script");
  inlineScript.id = "bitrix-widget-inline";
  inlineScript.innerHTML = `
    var hash = '${bitrixData.hash}';
    window.addEventListener('onBitrixLiveChat', function(event) {
      var widget = event.detail.widget;
      window.bitrixWidget = widget;
      widget.setOption('checkSameDomain', false);
      widget.setOption('crmFormsSettings', { useWelcomeForm: "N" });
      widget.setUserRegisterData({
        hash: hash,
      });

      if (hash) {
        var button = document.querySelector('${bitrixData.widgetCrmFormButton}');
        if (button) {
          button.style.display = 'none';
        }
      }	
    });	
    
    (function(w,d,u){
      var s = d.createElement('script');
      s.async = true;
      s.src = u + '?' + (Date.now()/60000|0);
      var h = d.getElementsByTagName('script')[0];
      h.parentNode.insertBefore(s, h);
    })(window,document,'${bitrixData.widgetUrl}');
  `;

  document.head.appendChild(inlineScript);
  bitrixScriptInjected = true;
}

// Helper to check if we should inject the script
function shouldInjectScript(state: any): Common.BitrixDataProps | null {
  // Check if Bitrix data is available
  const bitrixQuery = commonApi.endpoints.getBitrixData.select()(state);

  if (bitrixQuery?.data?.data && !bitrixQuery?.isError) {
    return bitrixQuery.data.data;
  }

  return null;
}

// Create the listener middleware instance
export const bitrixListenerMiddleware = createListenerMiddleware();

// Listen for logout action to hide the Bitrix widget
bitrixListenerMiddleware.startListening({
  actionCreator: logout,
  effect: () => {
    hideBitrixWidget();
  },
});

// Listen for auth state changes and Bitrix data fulfillment to inject/show the widget
bitrixListenerMiddleware.startListening({
  matcher: isAnyOf(changeCode, changeSessionId, commonApi.endpoints.getBitrixData.matchFulfilled),
  effect: (_action, listenerApi) => {
    const state = listenerApi.getState();
    const bitrixData = shouldInjectScript(state);

    if (bitrixData) {
      if (!bitrixScriptInjected) {
        setTimeout(() => {
          injectBitrixScript(bitrixData);
        }, 100);
      } else {
        setTimeout(() => {
          showBitrixWidget(bitrixData);
        }, 100);
      }
    }
  },
});
